import { combineReducers } from "redux";
import { ReportsAdministrationState, ReportAdministrationView } from "../ReportsState";
import { AdministrationAction, AdministrationActionType } from "./AdministrationActions";

export function administrationReducer(state: ReportsAdministrationState = null, action: AdministrationAction): ReportsAdministrationState {
    switch (action.type) {
        case AdministrationActionType.ChangeView:
            return {
                ...state,
                currentView: action.view,
            };
        case AdministrationActionType.ConnectedToReportServer:
            return {
                ...state,
                isConnectedToReportServer: true,
            };
        case AdministrationActionType.FailedToConnectToReportServer:
            return {
                ...state,
                isConnectedToReportServer: false,
            };
        case AdministrationActionType.ReceiveCredentials:
            return {
                ...state,
                credentials: action.credentials,
            };
        case AdministrationActionType.ReceiveFolders:
            return {
                ...state,
                availableFolders: action.folders,
            };
        case AdministrationActionType.ToggleReportServerConnectionVisibility:
            return {
                ...state,
                isConnectionModalVisible: !state.isConnectionModalVisible,
            };
        case AdministrationActionType.ToggleReportRolesVisibility:
            return {
                ...state,
                isReportRolesModalVisible: !state.isReportRolesModalVisible,
            };
        case AdministrationActionType.ReceiveReportRoles:
            return {
                ...state,
                availableRoles: action.roles,
            };
        case AdministrationActionType.SetActiveReport:
            return {
                ...state,
                activeReportId: action.reportId,
            };
        case AdministrationActionType.ToggleImportBaseReportsModalVisibility:
            return {
                ...state,
                isImportBaseReportsVisible: !state.isImportBaseReportsVisible,
            };
        case AdministrationActionType.SetSelectedRootFolder: {
            return {
                ...state,
                selectedStudyRootFolder: action.selectedRootFolder
            };
        }
        default:
            return state;
    }
}
